<template> 
    <div class="c-slider slider mb-5">
      <div class="">
        <!-- test {{item}} -->
		  	<!-- <responsive-image
          :alt="items.name"
          :title="items.name"
          v-bind:desktop="`${$root.image_url_c}inside/900x450/${$root.bottomBanner[0].image}`"
          v-bind:tab="`${$root.image_url_c}inside/700x380/${$root.bottomBanner[0].image}`"
          v-bind:mobile="`${$root.image_url_c}inside/500x350/${$root.bottomBanner[0].image}`"
          v-bind:default_image="`${$root.image_url_c}inside/900x450/${$root.bottomBanner[0].image}`"
        /> -->
          	<!-- :src="`${$root.image_url_c}inside/900x450/${$root.bottomBanner[0].image}`" -->
        <img
			    :src="`${$root.image_url_c}inside/1350x320/${item.image}`"
           class="img-fluid"
        />
      </div>
      <!-- <div class="slider__content">
        <img
          :src="`${$root.image_url_c}inside/130x130/${item.bottom_banner_logo}`"
        />
        <h3 class="mb-3">Fast–Forward your shopping –– With WNDW there’s no wait!</h3>
        <button class="slider__btn">Nearby Stores</button>
      </div> -->
    </div> 
</template>
<style>
.slider {
  display: flex !important;
  /* padding-top: 5rem; */
  /* Responsive */
}

.slider > .slick-dots {
  bottom: 10px !important;
}
.slider:focus {
  outline: none;
}
.slider__image {
  width: 75%;
  height: auto;
}
.slider__image img {
  height: 100%;
}
.slider__content {
  display: flex;
  justify-content: center;
  margin-left: 2rem;
  flex-direction: column;
  width: 25%;
}
.slider__content img {
  width: 100% !important;
  max-width: 200px;
  margin-bottom: 5px;
  padding: 1rem;
  margin: 0 auto;
}
.slider__content h3 {
  font-size: 26px;
  font-family: "lhmSemiBold";
  text-transform: none;
  word-wrap: break-word;
  margin: 10px 0px;
}
.slider__btn {
  padding: 0.75rem 1.5rem;
  width: 80%;
  background: #fff;
  border-radius: 5px;
  border: none;
}
@media screen and (max-width: 767px) {
  .slider {
    flex-direction: column;
    margin: 10px 0px;
    background: #fff;
    padding: 0px;
    padding-bottom: 20px;
    margin-bottom: 10px;
  }
  .slider__image {
    width: 100%;
  }
  .slider__content {
    width: 100%;
    text-align: center;
    display: block;
    margin-left: 0rem;
    font-family: lhmRegular;
    min-height: 160px;
  }
  .slider__content img {
    background: #fff;
    margin: auto;
    margin-top: -30px;
    margin-bottom: 0px;
  }
  .slider__content h3 {
    font-size: 16px;
    margin: 0px;
    margin-bottom: 23px;
    line-height: 24px;
  }
  .slider__btn {
    color: var(--main-color);
    border: 1px solid var(--main-color);
    font-size: var(--font-size-heading);
    line-height: 23px;
    width: 50%;
    border-radius: 0px;
    padding: 16px auto;
    margin-bottom: 10px;
  }
}
</style>
<script>
export default {
  props: ["item"],
};
</script>